import { cva } from 'class-variance-authority';

import s from './Typography.module.css';

export const typographyVariants = cva(null, {
  defaultVariants: {
    bold: false,
    color: 'white',
    preLine: false,
    variant: 'paragraph',
  },
  variants: {
    bold: {
      false: null,
      true: s['typography--bold'],
    },
    color: {
      accent: s['typography--color-accent'],

      'accent-act': s['typography--color-accent-act'],
      'accent-alt': s['typography--color-accent-alt'],

      'black-body': s['typography--color-black-body'],
      'black-modal': s['typography--color-black-modal'],
      danger: s['typography--color-danger'],
      'grey-dark': s['typography--color-grey-dark'],

      'grey-field': s['typography--color-grey-field'],
      'grey-light': s['typography--color-grey-light'],
      'grey-light-opacity-40': s['typography--color-grey-light-opacity-40'],

      success: s['typography--color-success'],
      white: s['typography--color-white'],
    },
    preLine: {
      false: null,
      true: s['typography--pre-line'],
    },
    variant: {
      'card-title': s['typography--variant-card-title'],
      'inset-paragraph': s['typography--variant-inset-paragraph'],
      'lead-paragraph': s['typography--variant-lead-paragraph'],

      note: s['typography--variant-note'],
      paragraph: s['typography--variant-paragraph'],
      'section-title': s['typography--variant-section-title'],

      title: s['typography--variant-title'],
    },
  },
});
